import { render, staticRenderFns } from "./productPay.vue?vue&type=template&id=58fb4519&scoped=true&"
import script from "./productPay.vue?vue&type=script&lang=js&"
export * from "./productPay.vue?vue&type=script&lang=js&"
import style0 from "./productPay.vue?vue&type=style&index=0&id=58fb4519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb4519",
  null
  
)

export default component.exports